import "./App.css";
import { Flex, Button, Tooltip } from "@chakra-ui/react";
import MonacoEditor from "@monaco-editor/react";
import { useRef, useState } from "react";
import { emmetHTML, emmetCSS } from "emmet-monaco-es";
import files from "./files";
import { useEffect } from "react";

function compile(iframe, writCode, writCodec) {
  var code = iframe.current.contentWindow.document;

  code.open();
  code.writeln(writCode + "<style>" + writCodec + "</style>");
  code.close();
}

function App() {
  const [fileName, setFileName] = useState("HTML");
  const file = files[fileName];

  const iframe = useRef();
  const [writCode, setwritCode] = useState();
  const [copied, setCopied] = useState(false);
  const [writCodec, setwritCodec] = useState();

  useEffect(() => {
    setwritCodec(files.CSS.value);
    setwritCode(files.HTML.value);
    compile(iframe, writCode, writCodec);
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    compile(iframe, writCode, writCodec);
  }, [writCode, writCodec]);
  return (
    <>
      <div className="App" style={{ overflow: "hidden" }}>
        <Flex
          width="100vw"
          height="100vh"
          flexDir="row"
          justifyContent="space-around"
          alignItems="center"
        >
          <Flex height="100%" width="50%" flexDir="column">
            <Flex flexDir="row">
              <Button
                _hover={{}}
                width="50%"
                backgroundColor={() => {
                  if (fileName === "CSS") {
                    return "blackAlpha.700";
                  } else {
                    return "orange.600";
                  }
                }}
                colorScheme="orange"
                borderRadius="none"
                className="run"
                onClick={() => setFileName("HTML")}
              >
                HTML
              </Button>
              <Button
                width="50%"
                _hover={{}}
                backgroundColor={() => {
                  if (fileName === "HTML") {
                    return "blackAlpha.700";
                  } else {
                    return "orange.600";
                  }
                }}
                colorScheme="orange"
                color="white"
                borderRadius="none"
                className="run"
                onClick={() => setFileName("CSS")}
              >
                CSS
              </Button>
            </Flex>
            <MonacoEditor
              value={writCode}
              onChange={(value) => {
                if (fileName === "HTML") {
                  setwritCode(value);
                } else {
                  setwritCodec(value);
                }
              }}
              loading="Setting up your web editors..."
              // defaultValue={code.html}
              // defaultLanguage="html"
              theme="vs-dark"
              onMount={(editor) => {
                if (fileName === "HTML") {
                  setwritCode(editor.getValue());
                } else {
                  setwritCodec(editor.getValue());
                }
              }}
              beforeMount={(editor) => {
                if (fileName === "HTML") {
                  // eslint-disable-next-line
                  const dispose = emmetHTML(editor, ["html"]);
                } else {
                  // eslint-disable-next-line
                  const dispose = emmetCSS(editor, ["css"]);
                }
              }}
              path={file.name}
              defaultLanguage={file.language}
              defaultValue={file.value}
            />
          </Flex>
          <Flex height="100%" width="50%" className="prev" flexDir="column">
            <Flex flexDir="row">
              {/* <Button
                width="70%"
                colorScheme="whatsapp"
                borderRadius="none"
                className="run"
                onClick={() => {
                  compile(iframe, writCode, writCodec);
                }}
              >
                Compile and run
              </Button> */}
              <Tooltip
                hasArrow
                label="Copy Data URL. You can paste this URL in a new tab to preview your changes without the code editor."
                bg="gray.300"
                color="black"
              >
                <Button
                  width="100%"
                  // width="30%"
                  colorScheme="twitter"
                  borderRadius="none"
                  className="run"
                  onClick={() => {
                    setCopied(true);
                    navigator.clipboard.writeText(
                      `data:text/html;charset=utf-8;base64,${btoa(
                        writCode +
                          "<style>" +
                          writCodec +
                          "</style>" +
                          "<!-- This file is created using Samcode Code Editor. https://samcodee.gitlab.io/samcode -->"
                      )}`
                    );
                    setTimeout(() => {
                      setCopied(false);
                    }, 5000);
                  }}
                >
                  {copied ? "Copied Data URL" : "Copy Data URL"}
                </Button>
              </Tooltip>
            </Flex>
            <iframe ref={iframe} className="ifr" title="Preview"></iframe>
          </Flex>
        </Flex>
      </div>
    </>
  );
}

export default App;
